angular.module 'zc.core'

# Support for pushState
.config ($locationProvider) ->
  $locationProvider
    .html5Mode({ enabled: true, requireBase: false })
    .hashPrefix('!')

.config ($httpProvider) ->
  authToken = $('meta[name="csrf-token"]').attr('content')
  $httpProvider.defaults.headers.common['X-CSRF-TOKEN'] = authToken
  $httpProvider.defaults.withCredentials = true

# IMPORTANT:
# Set X-Requested-Widh to header for rails to detect xhr request
# in order to stop rendering layout when xhr request
.config ($httpProvider) ->
  $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

.config ($httpProvider) ->
  $httpProvider.interceptors.push 'SessionRecoverer'

.config ($httpProvider) ->
  $httpProvider.interceptors.push 'errorInterceptor'

.config ($httpProvider) ->
  $httpProvider.interceptors.push 'notificationInterceptor'

# Support for LocalStorage
.config (localStorageServiceProvider) ->
  localStorageServiceProvider.setPrefix 'zc'

# Support for patch method
.config ($httpProvider) ->
  $httpProvider.defaults.headers.patch =
    'Content-Type': 'application/json;charset=utf-8'

# Required for iframe and src settings in viz
.config ($sceDelegateProvider) ->
  $sceDelegateProvider.resourceUrlWhitelist(['self', 'http://**', 'https://**'])



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/config/zc.core.settings.js.coffee